<template>
    <div id="search">
        <div class="flex-y-center">
            <h3 class="no-margin-t">Filter by Type</h3>
            <span class="link search-option" v-if="TotalTypesSelected()" @click="$emit('deselect-all-types')">Deselect All</span>
        </div>
        <div id="search-types" class="flex flex-wrap m-row">
            <div class="m-span search-type" v-for="(type, t) in types" :key="t">
                <Checkbox
                    :selected="type.selected"
                    :label="type.value"
                    :index="t"
                    @toggle="SelectCheckbox($event)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Checkbox from "@/components/Checkbox.vue";

export default {
    name: "PopupSearch",
    props: { types: Array },
    components: { Checkbox },
    methods: {
        SelectCheckbox: function(selection) {
            this.$emit("set-search", {
                selected: selection.selected,
                value: selection.value,
                index: selection.index
            });
        },
        TotalTypesSelected: function() {
            let totalTypesSelected = 0;
            for (const type of this.types) {
                if (type.selected) {
                    totalTypesSelected++;
                }
            }
            return totalTypesSelected;
        }
    },
    beforeMount: function() { this.TotalTypesSelected(); },
    emits: [
        "set-search",
        "deselect-all-types"
    ]
};
</script>